import { useCallback, useRef } from 'react'
import { RecoilState, useRecoilValue } from 'recoil'

type GetStateAction<S> = () => S
function useGetRecoilState<S>(recoilState: RecoilState<S>): [S, GetStateAction<S>] {
  const state = useRecoilValue(recoilState)
  const stateRef = useRef(state)
  stateRef.current = state

  const getState = useCallback(() => stateRef.current, [])

  return [state, getState]
}

export default useGetRecoilState
